var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 22,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2A2A2A",
    d: "M3.507 21.5h10.986c2.001 0 3.007-.968 3.007-2.884V9.33c0-1.917-1.006-2.884-3.007-2.884H11.82v1.498h2.643c.948 0 1.494.502 1.494 1.47v9.118c0 .968-.546 1.47-1.494 1.47H3.526c-.957 0-1.484-.502-1.484-1.47V9.414c0-.968.527-1.47 1.484-1.47H6.18V6.446H3.507C1.506 6.446.5 7.413.5 9.33v9.286c0 1.916 1.006 2.884 3.007 2.884"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A2A2A",
    d: "M9.005.5c-.412 0-.766.335-.766.726v9.555l.057 1.396-.641-.66-1.456-1.508a.7.7 0 0 0-.517-.223c-.393 0-.7.28-.7.66 0 .196.087.345.23.484l3.238 3.034c.191.186.354.25.555.25.192 0 .354-.064.556-.25l3.237-3.034a.64.64 0 0 0 .22-.483c0-.382-.287-.661-.69-.661a.73.73 0 0 0-.526.223l-1.447 1.508-.65.66.057-1.396V1.226c0-.39-.345-.726-.757-.726"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.fed28dd766749c845e2416f70cb8a353.svg";
export { ForwardRef as ReactComponent };